export const paths = {
  login: () => "/login",
  signup: () => "/signup",
  forgotPassword: () => "/forgot-password",
  accountVerification: () => "/account-verification",
  newVerificationCode: () => "/new-verification-code",
  deactivated: () => "/deactivated",
  resetPassword: (token = ":token") => `/reset-password/${token}`,
  chooseIntroVideoType: () => `/choose-intro-video-type`,
  accountDeleted: () => "/account-deleted",

  invitations: () => "/invitations",
  home: () => "/home",
  projects: () => "/projects",
  tasks: () => "/tasks",
  todos: () => "/todos",
  calendar: () => "/calendar",
  kanban: () => "/kanban",
  projectsDashboard: () => "/projects-dashboard",
  chat: () => "/chat",

  userInvited: () => `/users/invited`,
  userWelcome: () => `/users/welcome`,
  userSettings: () => `/users/settings`,
  newOrganisation: () => `/orgs/new`,

  orgWelcome: () => `/orgs/welcome`,
  orgNewMember: () => `/orgs/members/new`,
  orgMembers: () => `/orgs/members`,
  orgNewCustomer: () => `/orgs/customers/new`,
  orgNewSupplier: () => `/orgs/suppliers/new`,
  orgNewWorkspace: () => `/orgs/workspaces/new`,
  orgCustomers: () => `/orgs/customers`,
  orgSuppliers: () => `/orgs/suppliers`,
  orgWorkspaces: () => `/orgs/workspaces`,
  orgSettings: () => `/orgs/settings`,
  orgBilling: () => `/orgs/billing`,
  orgGeneralSettings: () => `/orgs/settings`,
  orgNotificationSettings: () => `/orgs/settings/notifications`,
  orgProjectSettings: () => `/orgs/settings/projects`,
  orgTaskSettings: () => `/orgs/settings/tasks`,
  orgNewProjectType: () => `/orgs/settings/projects/project-types/new`,
  orgProjectType: (id = ":projectTypeId") => `/orgs/settings/projects/project-types/${id}`,
  orgHolidaySettings: () => `/orgs/settings/holidays`,
  orgHourReportSettings: () => `/orgs/settings/hour-reports`,

  membershipSettings: () => `/memberships/settings`,
  membershipWelcome: () => `/memberships/welcome`,
  customerSettings: () => `/customers/settings`,
  supplierSettings: () => `/suppliers/settings`,
  workspaceWelcome: () => `/workspaces/welcome`,
  workspaceMembers: () => `/workspaces/members`,
  workspaceSettings: () => `/workspaces/settings`,

  newProject: () => `/projects/new`,
  projectBasic: (id = ":projectId") => `/projects/${id}/basic`,
  projectTasks: (id = ":projectId") => `/projects/${id}/tasks`,
  projectTodos: (id = ":projectId") => `/projects/${id}/todos`,
  projectCalendar: (id = ":projectId") => `/projects/${id}/calendar`,
  projectKanban: (id = ":projectId") => `/projects/${id}/kanban`,
  projectGantt: (id = ":projectId") => `/projects/${id}/gantt`,
  projectReportedHours: (id = ":projectId") => `/projects/${id}/reported-hours`,
  projectSettings: (id = ":projectId") => `/projects/${id}/settings`,
  projectReminders: (id = ":projectId") => `/projects/${id}/settings?tab=reminders`,
  projectDashboard: (id = ":projectId") => `/projects/${id}/dashboard`,
  projectChat: (id = ":projectId") => `/projects/${id}/chat`,

  newProjectTemplate: () => `/project-templates/new`,

  taskBasic: (id = ":taskId") => `/tasks/${id}/basic`,
  taskSubtasks: (id = ":taskId") => `/tasks/${id}/subtasks`,
  taskTodos: (id = ":taskId") => `/tasks/${id}/todos`,
  taskCalendar: (id = ":taskId") => `/tasks/${id}/calendar`,
  taskKanban: (id = ":taskId") => `/tasks/${id}/kanban`,
  taskReportedHours: (id = ":taskId") => `/tasks/${id}/reported-hours`,
  taskPermissions: (id = ":taskId") => `/tasks/${id}/permissions`,
  taskNotifications: (id = ":taskId") => `/tasks/${id}/notifications`,
  taskChat: (id = ":taskId") => `/tasks/${id}/chat`,

  hourReports: () => `/hour-reports`,
}
